import type { ReactNode } from 'react';

import css from './featured-row.module.css';

/** "Featured This Week": a swipeable row of 300 px cards on phones, a grid of four on desktop. */
export function FeaturedRow({ children }: { children: ReactNode }) {
  return (
    <div className={css.scroller}>
      <div className={css.row}>{children}</div>
    </div>
  );
}
